import { useState } from 'react';
import AccentTitle from '@/components/UI/AccentTitle';
import Button from '@/components/UI/Button';
import { ApplicationFormsList, NewApplicationForm } from '@/features/ApplicationForm';
import { usePermission } from '@/hooks/usePermission';
import { EPermission } from '@/types/Permission';

const ApplicationForms = () => {
  const [showNewForm, setShowNewForm] = useState(false);

  const { hasPermission } = usePermission();

  return (
    <>
      {showNewForm && <NewApplicationForm handleModal={() => setShowNewForm(false)} />}

      <div className='border bg-white rounded-xl w-full'>
        <div className=' sm:flex sm:items-center'>
          <div className='sm:flex-auto'>
            <AccentTitle
              title='Application Forms'
              subTitle=' A list of all the application forms in your account for the
              selected program.'
            />
          </div>
          {hasPermission([EPermission.CREATE_APPLICATION_FORM]) && (
            <div className='mt-4 sm:mt-0 sm:ml-16 sm:flex-none'>
              <Button label='Add Form' btnStyle='primary' customClassName='mr-5' onClick={() => setShowNewForm(true)} />
            </div>
          )}
        </div>
        <ApplicationFormsList />
      </div>
    </>
  );
};

export default ApplicationForms;
